function Action(props) {
	return null;
}

export default Action;
